import Element from '../components/Element';

/**
 * 反馈类
 * 反馈主要用于地图内部操作，如捕捉（snap）、工具(tool)、要素高亮等涉及少量对象的渲染和频繁刷新的场景，
 * 如果要进行大数据量的渲染绘制，请使用VectorLayer图层等类
 */
export default class Feedback extends Element {
    /**
     * 构造方法,初始化Feedback对象各属性.
     * @param {object} options 构造选项,包含flashInterval,priority两个选项
     */
    constructor(options = {}) {
        super({
            priority: 0, // 反馈的优先级
            flashInterval: 0, // 闪烁效果时间间隔
            ...options
        });

        /**
         * 反馈的几何和符号容器数组
         * @type {array}
         * */
        this._items = [];
        /**
         * 动态效果定时器
         * @type {object}
         * */
        this._timer = null;
    }

    /**
     * 添加到地图中
     * @param {Object}  map 地图对象
     */
    addTo(map) {
        if (map && map.FeedbackController) {
            return super.addTo(map.FeedbackController);
        }
        return null;
    }

    /**
     * 设置反馈管理器
     */
    setFeedbackController(value) {
        this.feedbackController = value;

        this._refreshTimer();
    }
    
    /**
     * 添加到控制器时调用，执行初始化操作
     * @param {object} controller 控制器实例
     */
    onAdd(controller) {
        super.onAdd(controller);

        this._refreshTimer();
    }

    /**
     * 从控制器中删除时调用，执行数据清理
     */
    onRemove() {
        if (this._timer) {
            clearInterval(this._timer);
        }

        super.onRemove();
    }

    /**
     * 设置反馈的动态效果间隔时间
     */
    resetFlashInterval(value) {
        this.options.flashInterval = value;

        this._refreshTimer();
    }

    /**
     * 刷新定时器
     */
    _refreshTimer() {
        if (this._timer) {
            clearInterval(this._timer);
        }

        if (this._controller && this.options.flashInterval > 0) {
            this._timer = setInterval(() => {
                if (this.enabled()) {
                    this.disable();
                } else {
                    this.enable();
                }
                this._controller.refresh();
            }, this.options.flashInterval);
        }
    }

    /**
     * 给反馈中的符号容器中添加用于绘制的符号
     * 可以是对象，也可以数组，对象/数组元素对象必须有geojson格式的geometry属性和json格式的symbol属性
     * @param {array<object>} data - 符号几何对象
     * @return {undefined}
     */
    addItems(data) {
        if (!data) {
            return;
        }

        let list = data;
        if (!Array.isArray(data)) {
            list = [data];
        }
        for (const rec of list) {
            if (rec.geometry && rec.symbol) {
                this._items.push(rec);
            }
        }
        
        this._refreshTimer();
    }

    /**
     * 清空反馈中的所有符号.
     * @return {undefined}
     */
    clear() {
        this._items = [];

        this._refreshTimer();
    }

    /**
     * 获得反馈对象中所有的原始项.
     * @returns {Array} - 原始项
     */
    getItems() {
        return this._items;
    }
}
